// @ts-expect-error untyped
import config from 'quartz-config-loader?{"forApp":true}!';
const quartzConfig = config;
export { quartzConfig };